import { LENGTH_FORMAT } from '@/helpers/unit.ts';
import { BagType } from './types';
// [maxThreshold, tolerance, inclusive] — inclusive means maxValue <= threshold, otherwise maxValue < threshold
type ToleranceRange = [number, number, boolean?];

const RIGID_TOLERANCE_RANGES: Record<LENGTH_FORMAT, ToleranceRange[]> = {
  [LENGTH_FORMAT.CM]: [
    [10, 0],
    [20, 1, true],
    [Infinity, 2],
  ],
  [LENGTH_FORMAT.IN]: [
    [4, 0],
    [8, 0.4],
    [Infinity, 0.8],
  ],
};

const SOFT_TOLERANCE: Record<LENGTH_FORMAT, number> = {
  [LENGTH_FORMAT.CM]: 5,
  [LENGTH_FORMAT.IN]: 2,
};

export function getTolerance(
  bagType: BagType,
  maxValue: number,
  unit: LENGTH_FORMAT
): number {
  if (bagType === 'soft') {
    return SOFT_TOLERANCE[unit];
  }

  const range = RIGID_TOLERANCE_RANGES[unit].find(([threshold, , inclusive]) =>
    inclusive ? maxValue <= threshold : maxValue < threshold
  );
  return range![1];
}

export function isWithinTolerance(
  sellerValue: number,
  agentValue: number,
  tolerance: number
): boolean {
  return Math.abs(sellerValue - agentValue) <= tolerance;
}
